import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
import { validateOrder } from '../utils/validate-order';
import { clearOrder } from './clear-order';
/**
 * Completes and clears the current in-progress order, and returns the [[OrderCompletion]].
 */
export const completeOrder = async () => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot complete order');
    const validationResult = validateOrder(order);
    if (!validationResult.isValid)
        throw new Error(`Cannot complete order. ${validationResult.message}`);
    let response;
    const deregisterAction = registerOrderAction('complete-order');
    try {
        response = await ocapiClient.instance.v1.orders.completion.create(order.id);
    }
    finally {
        deregisterAction();
    }
    clearOrder();
    return response;
};
